import { Hyperlink } from '@strata/react-hyperlink';

import { Page } from 'components/shared/Page';

export const StrataComponents = () => (
    <div>
        <Page
            pageTitle="Strata Components"
            pageDescription="The following link will redirect you to our master repository of all Strata components in Storybook."
            pageContent={
                <p>
                    <Hyperlink
                        linkText="Master Storybook"
                        navUrl="https://master--6149fd06d42343003accc051.chromatic.com"
                    />
                </p>
            }
        />
    </div>
);
